import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserCheck } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Panel, SectionLabel } from "@/components/common/ui-kit";

const KINDS = ["assigned", "intervention_assigned", "reassigned"];

export const AssignedToMe = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/notifications", { params: { limit: 100 } }).then((r) => setItems(r.data.items.filter((n) => KINDS.includes(n.type) && !n.read_at).slice(0, 8))).catch(() => setItems([]));
  }, []);
  if (!items?.length) return null;
  return (
    <Panel className="mb-6 border-brand-200 bg-brand-50/40 p-5" data-testid="dashboard-assigned-to-me">
      <SectionLabel>Assegnati a me · {items.length} da vedere</SectionLabel>
      <ul className="mt-3 divide-y divide-line">{items.map((n) => (
        <li key={n.id} className="py-2" data-testid={`assigned-item-${n.id}`}>
          <Link to={n.link || "/"} className="flex items-center gap-2 text-sm text-ink hover:text-brand-600">
            <UserCheck className="h-4 w-4 shrink-0 text-brand-500" /><span className="flex-1 truncate">{n.title}</span>
            <span className="text-xs text-slate-400">{fmtDateTime(n.created_at)}</span></Link></li>))}</ul>
    </Panel>
  );
};
